import { persistentPageConfig } from '@/schema/page-config'

// 与加载时的编辑内容比较，不把当前页、选择、缩放或封面当作业务修改。

export function editorContentSignature (project, activePageId, config, nodes) {
  if (project && Array.isArray(project.pages) && project.pages.length) {
    if (!project.pages.some(page => page.id === activePageId)) throw new Error('当前页面不存在，不能确认保存状态')
    return JSON.stringify({
      ...project,
      pages: project.pages.map(page => ({
        ...page,
        config: persistentPageConfig(page.id === activePageId ? config : page.config),
        nodes: page.id === activePageId ? nodes : page.nodes
      }))
    })
  }
  return JSON.stringify({ config: persistentPageConfig(config), nodes })
}
